import moment from "moment";
import React from "react";
import { Button } from "semantic-ui-react";
import BrandLogo from "../../components/BrandLogo";
import { formatShortDate } from "../../utilities";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  item: server.dto.ESignForMe
}

const ESignForMeRow = (props: Props) => {
  const { item } = props;

  const sendDateMoment = moment.utc(item.sendDate);
  // const dueDateMoment = sendDateMoment.add(item.dueInDays, "days");

  const displaySignNow = item.isDirectFromUser && !item.isSignedByMe;

  return <tr>

    <td>
      <BrandLogo brand={item.brand} />
    </td>

    <td>
      <div>
        <h4><a href={routes.eSign_Landing(item.secret).absolute}>{item.documentNumber}</a></h4>
      </div>
      {/* <div>
                {item.documentType}
            </div> */}

      {formatShortDate(sendDateMoment)}
    </td>

    <td>

    </td>

    {/* <td>
            {item.role.text}
        </td> */}
    {/*
        <td>
            {item.signatureCount} signatures collected
        </td> */}

    < td style={{ textAlign: "right" }}>
      {displaySignNow && <Button
        type="button"
        color="blue"
      >
        {RESX.ESign.SignNow}
      </Button>
      }
    </td>

  </tr >;
};

export default ESignForMeRow;